import { useRecoilTransaction_UNSTABLE } from "recoil"

import type { TransactionOperation } from "."
import { tryToAddEdge } from "./addEdge"
import { activityState } from "../../activity"
import { divergeTimeline } from "../timeline/transactions"

export const drawEdge: TransactionOperation<string> = (transactors, node2id) => {
  const edgeCreation = tryToAddEdge(transactors, node2id)
  console.debug({ edgeCreation })
  if (edgeCreation) {
    divergeTimeline(transactors, [edgeCreation])
  }
}

export const tryToDrawEdge: TransactionOperation<string> = (
  transactors,
  node2id,
) => {
  const activity = transactors.get(activityState)
  const noCurrentActivity = Boolean(activity) === false
  if (noCurrentActivity) {
    drawEdge(transactors, node2id)
  }
}

export const useTryToDrawEdge = (node2id: string): VoidFunction =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => tryToDrawEdge(transactors, node2id),
  )
